import type { SectionHeadingComponent } from "../../types";

/**
 * Section heading (h2). Premium pattern: the heading itself is INK (not green) in
 * Space Grotesk; the brand green lives in the optional uppercase `eyebrow` kicker
 * above, or — when no eyebrow is authored — in a short gradient rule below, so
 * every section keeps exactly one green accent.
 * Content: { text, size?, eyebrow?, align? } (eyebrow/align additive).
 */
export function SectionHeadingRenderer({ component }: { component: SectionHeadingComponent }) {
  const { text, size = "medium" } = component.content;
  const eyebrow = (component.content as { eyebrow?: string }).eyebrow;
  const align = (component.content as { align?: string }).align === "center" ? "center" : "left";
  const centered = align === "center";

  return (
    <div className={`mb-2 md:mb-3 lg:mb-4 ${centered ? "text-center" : ""}`}>
      {eyebrow ? <span className="apa-eyebrow">{eyebrow}</span> : null}
      <h2
        className={`${eyebrow ? "mt-1.5" : ""} text-xl font-bold tracking-tight text-[#0A0A0A] ${size === "large" ? "md:text-3xl" : "md:text-2xl"}`}
        style={{ fontFamily: "var(--font-aleo)" }}
      >
        {text}
      </h2>
      {!eyebrow ? (
        <div
          className={`mt-2.5 h-1 w-10 rounded-full bg-[#00B862] ${centered ? "mx-auto" : ""}`}
          aria-hidden="true"
        />
      ) : null}
    </div>
  );
}
